import actionTypes from '../constants/actionTypes';
import { getAllClosures } from '../../../../../../services/accounting/closures';

export const getClosureStatsAction = (page, pageSize) => async (dispatch) => {
  const { CLOSURE_DATA_FETCH, CLOSURE_DATA_SUCCESS, CLOSURE_DATA_ERROR } = actionTypes;
  dispatch({ type: CLOSURE_DATA_FETCH });
  try {
    const payload = await getAllClosures(page, pageSize);
    dispatch({ type: CLOSURE_DATA_SUCCESS, payload: payload });
  } catch (error) {
    const errorResponse = error.response;
    dispatch({ type: CLOSURE_DATA_ERROR, error: errorResponse });
  }
};
